export default __webpack_public_path__ + "static/media/backgroundTiny.8d66f7de.png";